module.exports = __webpack_public_path__ + "img/flavor_strawberry.3c15b70c.png";